import React from 'react';
import { Box, MenuItem, Pagination, Select, Stack, Typography } from '@mui/material';
/** A compact, human-readable pager for data-entry tables. */
export default function DataEntryPager({ total, page, pageSize, onPageChange, onPageSizeChange }) {
    if (total === 0)
        return null;
    const pageCount = Math.max(1, Math.ceil(total / pageSize));
    const first = page * pageSize + 1;
    const last = Math.min(total, (page + 1) * pageSize);
    return (React.createElement(Box, { component: "footer", sx: {
            px: 2,
            py: 1,
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: '#fafcfb',
            flexShrink: 0,
        } },
        React.createElement(Stack, { direction: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: "space-between", spacing: 1 },
            React.createElement(Typography, { variant: "body2", color: "text.secondary" },
                "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E ",
                first,
                "\u2013",
                last,
                " \u0438\u0437 ",
                total),
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5, flexWrap: "wrap", useFlexGap: true },
                React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 0.5 },
                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:"),
                    React.createElement(Select, { size: "small", value: pageSize, inputProps: { 'aria-label': 'Количество записей на странице' }, onChange: (event) => onPageSizeChange(Number(event.target.value)), sx: { minWidth: 64, bgcolor: 'background.paper' } }, [25, 50, 100].map((size) => React.createElement(MenuItem, { key: size, value: size }, size)))),
                pageCount > 1 && (React.createElement(Pagination, { count: pageCount, page: page + 1, onChange: (_event, value) => onPageChange(value - 1), color: "primary", size: "small", siblingCount: 0, boundaryCount: 1, showFirstButton: true, showLastButton: true }))))));
}
